import styled, { css } from 'styled-components';

import type { DrawerNavbarVariant } from './DrawerNavbar';

const NAVBAR_VARIANTS = {
  primary: css`
    background: linear-gradient(180deg, rgba(0, 0, 0, 0.35) 13.26%, rgba(0, 0, 0, 0) 102%);
    //color: white;

    color: ${({ theme }) => theme.color.primaryForeground};
  `,
  secondary: css`
    background-color: unset;
    color: ${({ theme }) => theme.color.bodyTextColor};
  `,
} as const;

export const StyledNavWrapper = styled.div<{ $opened: boolean }>`
  display: flex;
  flex-direction: column;
  position: fixed;
  height: 100vh;
  width: 100vw;
  top: 0;
  background-color: ${({ theme }) => theme.color.offWhite};
  z-index: 10;
  transform: ${({ $opened }) => ($opened ? 'translateX(0)' : 'translateX(100%)')};
  transition: transform 0.3s ease-in-out;
  overscroll-behavior: contain;
  overscroll-behavior-y: contain;
`;

export const StyledNavTrigger = styled.div<{ $variant: DrawerNavbarVariant }>`
  margin-top: 45px;
  display: flex;
  flex: 1;
  height: 100px;
  max-height: 100px;
  justify-content: center;
  align-items: center;
  position: absolute;
  left: 0;
  top: 0;
  right: 0;
  z-index: 10;
  ${(props) => NAVBAR_VARIANTS[props.$variant]}

  & > img {
    height: 100px;
    width: 100px;
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
  }
`;
export const StyledCloseMenuButton = styled.div`
  font-size: 24px;
  color: ${({ theme }) => theme.color.bodyTextColor};
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 0.25rem;
`;
export const StyledOpenMenuButton = styled(StyledCloseMenuButton)<{ $variant: DrawerNavbarVariant }>`
  position: absolute;
  right: 20px;
  height: 100px;
  display: flex;
  align-items: center;
  color: ${({ $variant, theme }) =>
    $variant === 'primary' ? theme.color.primaryForeground : theme.color.bodyTextColor};
`;

export const StyledNavHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 4rem 10%;

  & > img {
    height: 100px;
    width: 100px;
  }
`;

export const StyledNavItemsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 3rem;
  padding: 1rem 3rem;
`;
export const StyledNavItem = styled.div<{ $active?: boolean }>`
  font-size: 24px;
  font-weight: 500;
  color: ${({ theme }) => theme.color.bodyTextColor};
  display: flex;
  justify-content: space-between;
  ${({ $active }) =>
    $active &&
    css`
      text-decoration: underline;
    `}
`;
export const StyledArrowTail = styled.span`
  color: ${({ theme }) => theme.color.bodyTextColor};
`;
